import React from "react";
import { Select } from "antd";

const { Option } = Select;

function TrackedWebsitesSelector(props) {
  return (
    <Select
      className="tracked_websites_selector"
      size="large"
      value={props.selectedWebsite}
      onChange={props.handleTrackedWebsiteChange}>
      {props.trackedWebsites.map((trackedWebsite) => (
        <Option value={trackedWebsite.guid} key={trackedWebsite.guid}>
          {trackedWebsite.url}
        </Option>
      ))}
    </Select>
  );
}

export default TrackedWebsitesSelector;
